import { 
  SET_CONFIRM_PASSCODE_MODAL_VISIBILITY,
  SET_PASSCODE_VERFICATION,
} from '../actions/type';

const INITIAL_STATE = {
  confirmPasscodeModal: {
    visibility: false,
    verified: false,
  },
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_CONFIRM_PASSCODE_MODAL_VISIBILITY:
      return {
        ...state,
        confirmPasscodeModal: {
          ...state.confirmPasscodeModal,
          visibility: action.payload,
        },
      };
    case SET_PASSCODE_VERFICATION:
      return {
        ...state,
        confirmPasscodeModal: {
          ...state.confirmPasscodeModal,
          verified: action.payload,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/baseModals_reducers.js